import React from "react";
import { useEffect, useState } from "react";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import "./Project.scss";
import { Outlet } from "react-router-dom";
import medipulseImg from "../../assets/project/medipulse.png";
import gohireImg from "../../assets/project/gohire.png";
import dispatchxImg from "../../assets/project/dispatchx.png";

const projects = [
  {
    title: "DispatchX",
    image: dispatchxImg,
    description:
      "Engineered a production-grade distributed email delivery platform using a microservices architecture with RabbitMQ, Transactional Outbox Pattern, and Redis sliding-window rate limiting for fault-tolerant, high-throughput single, bulk, and scheduled email delivery. Implemented idempotent consumers, DLQ with retry/backoff, Docker-based deployment, CI/CD via GitHub Actions, and full observability with Prometheus and Grafana.",
    techStack: ["NodeJS", "RabbitMQ", "MongoDB", "Redis", "Docker", "Prometheus", "Grafana", "ReactJS"],
    github: "https://github.com/rathoreanuj/DispatchX",
    liveLinks: [],
    comingSoon: true,
  },
  {
    title: "Medipulse",
    image: medipulseImg,
    description:
      "Architected a full-stack hybrid healthcare platform with concurrency-safe slot booking using MongoDB and partial unique index with automatic rollback on payment failure. Built a unified real-time backend handling chat, notifications, and WebRTC signaling via Socket.io with JWT re-auth, alongside Gemini API symptom triage with resilient fallback.",
    techStack: ["NodeJS", "MongoDB", "Socket.io", "WebRTC", "JWT", "Stripe", "Gemini API"],
    github: "https://github.com/rathoreanuj/Medipulse",
    liveLinks: [
      { label: "Patient Portal", url: "https://medipulse-frontend.onrender.com/" },
      { label: "Admin/Doctor Portal", url: "https://medipulse-admin.onrender.com/" },
    ],
  },
  {
    title: "GoHire",
    image: gohireImg,
    description:
      "Developed a full-stack hiring marketplace spanning 5 core modules: company verification, job/internship lifecycle, resume applications, recruiter review, and dual-sided premium subscriptions. Structured a 3-database domain-separated architecture with FuseJS search, Redis caching, REST/GraphQL layer, and GridFS storage.",
    techStack: ["Redis", "GraphQL", "ReactJS", "NodeJS", "MongoDB", "ExpressJS", "GridFS"],
    github: "https://github.com/SSwanshi/JobPortal-GoHire",
    liveLinks: [{ label: "Live Demo", url: "https://gohire-applicant.vercel.app/" }],
  },
];

function Project() {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3300);
  }, []);

  return (
    <>
      <div className="container project-page">
        <div className="page">
          <span className="tags top-html">&lt;/html&gt;</span>
          <span className="tags top-tags">&lt;body&gt;</span>

          <div className="text-zone">
            <h1>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={[
                  "M",
                  "y",
                  " ",
                  "P",
                  "r",
                  "o",
                  "j",
                  "e",
                  "c",
                  "t",
                  "s",
                ]}
                idx={15}
              />
            </h1>
            <p>
              I build full-stack applications that balance elegant user
              experiences with robust backend engineering. Each project reflects
              my focus on clean architecture, efficient execution, and solving
              real-world problems.
            </p>
          </div>

          <div className="projects-grid">
            {projects.map((project, index) => (
              <div className="project-card" key={index}>
                {project.image && (
                  <div className="card-image">
                    <img src={project.image} alt={project.title} />
                  </div>
                )}
                <div className="card-body">
                <h3 className="card-title">{project.title}</h3>
                <p className="card-description">{project.description}</p>
                <div className="card-footer">
                  {project.github && (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noreferrer"
                      className="github-btn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        width="16"
                        height="16"
                      >
                        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22" />
                      </svg>
                      Code
                    </a>
                  )}
                  {project.liveLinks && project.liveLinks.length > 0 ? (
                    <a
                      href={project.liveLinks[0].url}
                      target="_blank"
                      rel="noreferrer"
                      className="live-btn"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        width="14"
                        height="14"
                      >
                        <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
                        <polyline points="15 3 21 3 21 9" />
                        <line x1="10" y1="14" x2="21" y2="3" />
                      </svg>
                      Live Demo
                    </a>
                  ) : project.comingSoon ? (
                    <span className="coming-soon-btn">Live Demo Coming Soon</span>
                  ) : null}
                </div>
                </div>
              </div>
            ))}
          </div>

          <Outlet />
          <span className="tags bottom-tags">
            &lt;/body&gt;
            <br />
            <span className="bottom-tag-html">&lt;/html&gt;</span>
          </span>
        </div>
      </div>
    </>
  );
}

export default Project;